import { FC } from "react";
import { Form, Alert, Select } from "antd";
import { useGetMasterCancel } from "hooks/useMasterData";
const { Option } = Select;

interface CancelOrderDialogProps {
  paidStatus: string;
}

const CancelOrderDialog: FC<CancelOrderDialogProps> = ({
  paidStatus
}) => {
  const { data: dataCancel } = useGetMasterCancel();
  const childrenCancel: React.ReactNode[] = [];
 // childrenCancel.push(<Option value="">ระบุเหตุผลการยกเลิกคำสั่งซื้อ</Option>);
  dataCancel?.data?.map((item) => {
    return childrenCancel.push(
      <Option key={item.id} value={item.id}>
        {item.description}
      </Option>
    );
  });
  return (
      <>
        <Form.Item
          labelAlign="left"
          label="เหตุผลการยกเลิก"
          name="reason_id"
        >
          <Select
            placeholder="ระบุเหตุผลการยกเลิกคำสั่งซื้อ"
          >
            {childrenCancel}
          </Select>          
        </Form.Item>
        {/* {paidStatus === "confirm" && (
          <>
          <Form.Item
              labelAlign="left"
              label="เหตุผลการยกเลิก"
              name="cancel_images"
            >
              <UploadImages maximumUploadItems={1} allowFileExtensions={allowFileExtensionsImage}/>
            </Form.Item>
          </>
        )} */}
        <Alert
          message="ข้อควรปฎิบัติ และ แจ้งเตือน"
          description='กรุณาตรวจสอบเลขที่คำสั่งซื้อที่ต้องการยกเลิก ก่อนปุ่มบน"ยืนยัน"'
          type="warning"
          showIcon
        />
      </>
    
  );
}
export default CancelOrderDialog;
